import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Step indicator component for PostBoxModal
 */
const StepIndicator = ({ stepNumber, current, done, icon, label }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'default',
        opacity: current || done ? 1 : 0.6, // Dim non-active/non-done steps
        transition: 'opacity 0.3s ease',
      }}
    >
      <Box
        sx={{
          width: '48px', // Further increased size for better visibility
          height: '48px', // Further increased size for better visibility
          borderRadius: '50%',
          backgroundColor: current ? '#2196f3' : done ? '#4caf50' : '#e0e0e0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
          mb: 0.5, // Space between icon and label
          fontSize: '24px', // Further increased icon size
        }}
      >
        {icon}
      </Box>
      <Typography
        variant="caption"
        sx={{
          color: current ? '#2196f3' : done ? '#4caf50' : '#616161',
          fontWeight: current || done ? 600 : 400,
          fontSize: '0.9rem', // Further increased font size for label
          textAlign: 'center',
          whiteSpace: 'nowrap', // Prevent label wrap
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default StepIndicator;
